<template>
  <div class="developer-list">
    <EmptyBanner v-if="list.length===0" :label="$t('bounty.developerEmpty')" />
    <div v-else class="g-box wrapper">
      <div v-for="item in list" :key="item.id" class="item">
        <UserItem class="user" :avatar="item.UserInfo.avatar" :name="item.UserInfo.name" :ont="item.UserInfo.ontid" />
        <div v-if="item.submit_status===BOUNTY_STATUS.pass" class="status success">{{ $t('bounty.developed') }}</div>
        <div v-else class="status refused">{{ $t('bounty.developing') }}</div>
      </div>
    </div>
    <NouPagerLight
      v-if="total>0"
      class="g-bottom-pager"
      v-model="currentPage"
      :total="total"
      :size="CONFIG.pageSize"
      @change="fetchList"
    />
  </div>
</template>

<script>

import URLS from '@/config/url';
import { BOUNTY_STATUS, CONFIG } from '@/config/enum';
import UserItem from '@/components/UserItem.vue';
import EmptyBanner from '@/components/EmptyBanner.vue';

export default {
  name: 'DeveloperList',
  components: { EmptyBanner, UserItem },
  data() {
    return {
      list: [],
      currentPage: 1,
      total: 0,
      CONFIG,
      BOUNTY_STATUS,
    };
  },
  methods: {
    fetchList() {
      this.$request({
        url: URLS.getDeveloperList,
        method: 'post',
        data: {
          id: Number(this.$route.query.id),
          page_size: CONFIG.pageSize,
          page_number: this.currentPage,
        },
      }).then(({ result }) => {
        this.list = result.list;
        this.total = result.total;
      });
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .developer-list {
    margin-top: $padding-sm;
  }

  .wrapper {
    padding: 0 $padding-common;
  }

  .item {
    display: flex;
    align-items: center;
    padding: $padding-common 0;
    line-height: 40px;
    & + & {
      border-top: 1px solid var(--border-common);
    }
  }

  .user {
    flex: 1;
  }

  .status {
    display: inline-block;
    padding: 0 10px;
    line-height: 32px;
    border-radius: 2px;
    font-size: 12px;

    &.success {
      background: #7FC050;
      color: #ffffff;
    }

    &.refused {
      background: var(--background-btn-disable);
      color: var(--color-des);
    }
  }
</style>
